
import request from '@/utils/request'
import host from '@/api/base/host'

// 课程分享
const camp = host.path('loca:ljs', { module: 'camp', dev: 'v1' })

export default {
  // 训练营列表
  periodsList(data) {
    return request({
      url: camp('camp/train/periods'),
      method: 'post',
      data
    })
  },
  // 训练营报名
  periodsJoin(data) {
    return request({
      url: camp('camp/train/join'),
      method: 'post',
      data
    })
  }
}